module.exports = __webpack_public_path__ + "img/badge-fastest-conversion-silver.89cfa90a.png";